import { useLiveQuery } from "dexie-react-hooks"

import type { LiveQueryResult } from "../../types"
import {
  type ClaimMarkerLocal,
  getClaimMarkersByPhoto,
  getClaimMarkersBySession,
  getPendingClaimMarkerDeletions,
  getPendingClaimMarkersForUpload,
} from "./claimMarkers"

export function useClaimMarkersByPhoto(photoId: string): LiveQueryResult<ClaimMarkerLocal[]> {
  return useLiveQuery(async () => ({ data: await getClaimMarkersByPhoto(photoId), isLoading: false }), [photoId], {
    data: undefined,
    isLoading: true,
  })
}

export function useClaimMarkersBySession(sessionId: string): LiveQueryResult<ClaimMarkerLocal[]> {
  return useLiveQuery(
    async () => ({ data: await getClaimMarkersBySession(sessionId), isLoading: false }),
    [sessionId],
    {
      data: undefined,
      isLoading: true,
    },
  )
}

export function usePendingClaimMarkersForUpload(sessionId: string): LiveQueryResult<ClaimMarkerLocal[]> {
  return useLiveQuery(
    async () => ({ data: await getPendingClaimMarkersForUpload(sessionId), isLoading: false }),
    [sessionId],
    {
      data: undefined,
      isLoading: true,
    },
  )
}

export function usePendingClaimMarkerDeletions(sessionId: string): LiveQueryResult<ClaimMarkerLocal[]> {
  return useLiveQuery(
    async () => ({ data: await getPendingClaimMarkerDeletions(sessionId), isLoading: false }),
    [sessionId],
    {
      data: undefined,
      isLoading: true,
    },
  )
}
